// src/components/Loader.js
import React from "react";
import { useLoader } from "../context/LoaderContext";

export default function Loader() {
  const { loading } = useLoader();

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center 
      bg-black/20 backdrop-blur-sm transition-opacity duration-300
      ${loading ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    >
      <div className="loader2 h-[50px] w-[20px]"></div>
    </div>
  );
}